import { createNamedActions } from 'utils/namedActionTypesProxy';

export const GLOBAL_UI_ACTION_TYPE = createNamedActions('globalUi', {
  SET_SCREEN_INFO: 'SET_SCREEN_INFO',
});

export const setScreenInfo = screenInfo => dispatch => {
  return dispatch({
    type: GLOBAL_UI_ACTION_TYPE.SET_SCREEN_INFO,
    payload: screenInfo,
  });
};
